// import React, { useCallback, useEffect, useState } from "react";
// import {
//   Typography,
//   Grid,
//   Divider,
//   Box,
//   Paper,
//   Container,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Button,
//   Stack,
// } from "@mui/material";
// import CheckIcon from "@mui/icons-material/Check";
// import { axiosClient } from "../../../../utils/auth.util";
// import { useNavigate } from "react-router-dom";

// const SubjectiveTestComponent = (props) => {
//   const [termscondition, setTermsConditions] = useState([]);
//   const [answers, setAnswers] = useState([]);
//   const [results, setResults] = useState([]);
//   const [examId, setExamId] = useState('')

//   // const [casests, setCasests] = useState("pending");

//   const find_examId = useCallback(async () => {
//     const response = await axiosClient.post(
//       "/tutorWeb/find_examId",
//       {
//         tutorId: JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id,
//       }
//     );

//     if (response.status === 201 || response.status === 200) {
//       console.log(response.data.tutStatus, "<<<< tut status");
//       let status = response.data.tutStatus
//       let obj
//       if (response.data.lastExamId) {
//         obj = response.data.tutor_exam.find(exam => exam.exam_id === response.data.lastExamId)
//         console.log('✌️obj --->', obj);
//         // dispatch(setExamObj(obj))
//         if (status === 'sube') {
//           // examId = response.data.lastExamId;
//           // subject = obj.subject
//           // marks = (+obj.mcqMarks) * 4;
//           // resultStatus = obj.mcqStatus
//           setExamId(response.data.lastExamId)
//         }
//         else if (status === 'mcqs') {
//           history('/register-dashboard/tutor_exam',{replace:true})
//         }
//         else if (status === 'mcqe') {
//           history('/register-dashboard/tutor_exam/submitted',{replace:true})

//         }
//         else if (status === 'subs') {
//           history('/register-dashboard/tutor_exam/subjective_sheet',{replace:true})

//         }
//       }

//     }
//   }, []);
//   useEffect(() => {
//     find_examId()
//   }, [])
//   const getTermsCondition = useCallback(async () => {
//     try {
//       const response = await axiosClient.get(
//         "/tutorweb/tnc/1"
//       );

//       if (response.status === 200 || response.status === 201) {
//         setTermsConditions(response.data.questions);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   }, []);

//   useEffect(() => {
//     getTermsCondition();
//   }, [getTermsCondition]);

//   useEffect(() => {
//     if (termscondition.length > 0) {
//       setAnswers(Array(termscondition.length).fill(null));
//       setResults(Array(termscondition.length).fill(null));
//     }
//   }, [termscondition]);

//   const handleChange = (index, value) => {
//     const newAnswers = [...answers];
//     newAnswers[index] = value;
//     setAnswers(newAnswers);

//     const newResults = [...results];
//     if (termscondition[index].answer === value) {
//       newResults[index] = "correct";
//     } else {
//       newResults[index] = "incorrect";
//     }
//     setResults(newResults);
//   };

//   const history = useNavigate();

//   const dashboardEntry = async () => {
//     let tutor1 = JSON.parse(localStorage.getItem("tutor"));
//     let tutor_ls = JSON.parse(localStorage.getItem("tutor")).saveTutor;

//     let temp_tutorSaveObj = {
//       ...tutor_ls,
//       tutStatus: "db",
//     };
//     console.log({ tutor_ls });
//     let temp_tutorObj = {
//       ...tutor1,
//       saveTutor: temp_tutorSaveObj,
//     };
//     let tutor_stringified = JSON.stringify(temp_tutorObj);
//     localStorage.setItem("tutor", tutor_stringified);

//     const res = await axiosClient.post(
//       `/tutorweb/setTutStatus/${JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id}`,
//       { tutStatus: "db" }
//     );
//     if (res.data) {
//       history("/register-dashboard",{replace:true});
//       window.location.reload();
//     } else {
//       console.log("not saved tutStatus in db");
//     }
//   };

//   const accpetTerms = async () => {
//     try {
//       console.log({results})
//       let allQuestionsAnswered = true 
//       results.forEach((each) => {
//         if(!each){
//           allQuestionsAnswered = false
//         }
//       })
//       if(!allQuestionsAnswered){
//         alert("Please answer all the questions")
//         return
//       }
//       console.log("submitted")
//       const response = await axiosClient.post(
//         "/tutorweb/submit-tnc",
//         {
//           tutorId: JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id,
//           examId: examId,
//         }
//       );

//       if (response.status === 200 || response.status === 201) {
//         alert("Submitted");
//         dashboardEntry();
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   return (
//     <div
//       style={{ marginTop: "7.5rem" }}
//       className="max-w-screen-md mx-auto py-2 "
//     >
//       <div className="flex justify-between items-center">
//         <div
//           style={{ textAlign: "left", dataAlign: "right" }}
//           className="form-buttons-wrapper form-buttons-center jsTest-button-wrapperField"
//         >
//           <Button variant="outlined">Show</Button>
//         </div>
//         <div
//           style={{ textAlign: "right", dataAlign: "right" }}
//           className="form-buttons-wrapper form-buttons-center jsTest-button-wrapperField"
//         >
//           <Stack flexDirection="row" gap={2}>
//             <Button
//               type="button"
//               variant="contained"
//               onClick={() => accpetTerms()}
//             >
//               Submit
//             </Button>
//           </Stack>
//         </div>
//       </div>
//       <Grid
//         container
//         spacing={2}
//         sx={{
//           marginTop: "2.1rem",
//           border: "3px solid #00a4bd",
//           borderRadius: "7px",
//           padding: "10px 8px",
//         }}
//       >
//         <Grid item xs={12}>
//           <Typography
//             variant="h5"
//             sx={{
//               fontFamily: "Poppins",
//               fontSize: "18px",
//               fontWeight: "medium",
//             }}
//           >
//             Terms & Conditions
//           </Typography>
//           <Divider
//             sx={{
//               backgroundColor: "#fcfcfc",
//               height: "1.73px",
//               borderRadius: "8px",
//               marginTop: "1.2px",
//             }}
//           />
//         </Grid>
//         <Grid item xs={12}>
//           <Container maxWidth="md" style={{ padding: "0" }}>
//             <div>
//               <p>Follow the rules for Terms & Conditions</p>
//               <ul>
//                 <li>Once you choose the answer, it will not be reversed.</li>
//                 <li>
//                   You can instantly view the answers upon answering the
//                   question.
//                 </li>
//               </ul>
//             </div>
//             <Paper elevation={3} style={{ padding: "15px 15px" }}>
//               {termscondition &&
//                 termscondition.map((question, index) => (
//                   <Box key={index} mb={4}>
//                     <Typography
//                       sx={{
//                         fontFamily: "Poppins",
//                         fontSize: "14px",
//                         textAlign: "justify",
//                       }}
//                       variant="h6"
//                       component="h2"
//                       gutterBottom
//                     >
//                       {question.question}
//                     </Typography>
//                     <RadioGroup
//                       row
//                       aria-labelledby={`question-${index}-label`}
//                       name={`question-${index}-radio-group`}
//                       value={answers[index] || ""}
//                       onChange={(event) =>
//                         handleChange(index, event.target.value)
//                       }
//                       sx={{ display: "flex", flexDirection: "column" }}
//                     >
//                       {question.options.map((option, optionIndex) => (
//                         <FormControlLabel
//                           key={optionIndex}
//                           value={option}
//                           control={<Radio />}
//                           label={option}
//                           disabled={results[index] !== null}
//                         />
//                       ))}
//                     </RadioGroup>
//                     {results[index] === "correct" && (
//                       <Typography
//                         sx={{
//                           color: "green",
//                           fontFamily: "Poppins",
//                           fontSize: "14px",
//                         }}
//                       >
//                         Correct answer
//                       </Typography>
//                     )}
//                     {results[index] === "incorrect" && (
//                       <Typography
//                         sx={{
//                           color: "red",
//                           fontFamily: "Poppins",
//                           fontSize: "14px",
//                         }}
//                       >
//                         Incorrect answer
//                       </Typography>
//                     )}
//                     {results[index] !== null && (
//                       <Typography
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           color: "green",
//                           fontFamily: "Poppins",
//                           fontSize: "14px",
//                         }}
//                       >
//                         <CheckIcon sx={{ marginRight: "4px" }} />
//                         {termscondition[index].answer}
//                       </Typography>
//                     )}
//                   </Box>
//                 ))}
//             </Paper>
//           </Container>
//         </Grid>
//       </Grid>
//     </div>
//   );
// };

// export default SubjectiveTestComponent;


import React, { useCallback, useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Divider,
  Box,
  Paper,
  Container,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Stack,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { axiosClient } from "../../../../utils/auth.util";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateUserData } from "../../../../redux/slice/registerSlice";

const SubjectiveTestComponent = (props) => {
  const [termscondition, setTermsConditions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [results, setResults] = useState([]);
  const [examId, setExamId] = useState('');
  
  const history = useNavigate();
  const dispatch = useDispatch();
  
  // Get userData from Redux instead of localStorage
  const userData = useSelector(state => state.register.userData);

  const find_examId = useCallback(async () => {
    if (!userData) return;

    const response = await axiosClient.post("/tutorWeb/find_examId", {
      tutorId: userData?.tutor_id || userData?._id,
    });

    if (response.status === 201 || response.status === 200) {
      console.log(response.data.tutStatus, "<<<< tut status");
      let status = response.data.tutStatus;
      let obj;

      if (response.data.lastExamId) {
        obj = response.data.tutor_exam.find(
          exam => exam.exam_id === response.data.lastExamId
        );
        console.log('✌️obj --->', obj);

        if (status === 'sube') {
          setExamId(response.data.lastExamId);
        } else if (status === 'mcqs') {
          history('/register-dashboard/tutor_exam', { replace: true });
        } else if (status === 'mcqe') {
          history('/register-dashboard/tutor_exam/submitted', { replace: true });
        } else if (status === 'subs') {
          history('/register-dashboard/tutor_exam/subjective_sheet', { replace: true });
        }
      }
    }
  }, [userData, history]);

  useEffect(() => {
    find_examId();
  }, [find_examId]);

  const getTermsCondition = useCallback(async () => {
    try {
      const response = await axiosClient.get("/tutorweb/tnc/1");

      if (response.status === 200 || response.status === 201) {
        setTermsConditions(response.data.questions);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getTermsCondition();
  }, [getTermsCondition]);

  useEffect(() => {
    if (termscondition.length > 0) {
      setAnswers(Array(termscondition.length).fill(null));
      setResults(Array(termscondition.length).fill(null));
    }
  }, [termscondition]);

  const handleChange = (index, value) => {
    const newAnswers = [...answers];
    newAnswers[index] = value;
    setAnswers(newAnswers);

    const newResults = [...results];
    if (termscondition[index].answer === value) {
      newResults[index] = "correct";
    } else {
      newResults[index] = "incorrect";
    }
    setResults(newResults);
  };

  const dashboardEntry = async () => {
    // Update Redux state instead of localStorage
    dispatch(updateUserData({ tutStatus: "db" }));

    const res = await axiosClient.post(
      `/tutorweb/setTutStatus/${userData?.tutor_id || userData?._id}`,
      { tutStatus: "db" }
    );

    if (res.data) {
      history("/register-dashboard", { replace: true });
      window.location.reload();
    } else {
      console.log("not saved tutStatus in db");
    }
  };

  const acceptTerms = async () => {
    try {
      console.log({ results });
      let allQuestionsAnswered = true;
      results.forEach((each) => {
        if (!each) {
          allQuestionsAnswered = false;
        }
      });

      if (!allQuestionsAnswered) {
        alert("Please answer all the questions");
        return;
      }

      console.log("submitted");
      const response = await axiosClient.post("/tutorweb/submit-tnc", {
        tutorId: userData?.tutor_id || userData?._id,
        examId: examId,
      });

      if (response.status === 200 || response.status === 201) {
        alert("Submitted");
        dashboardEntry();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Follow the rules for Terms & Conditions
        </Typography>
        
        <Divider sx={{ my: 3 }} />

        {termscondition.map((question, index) => (
          <Box key={index} sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              Question {index + 1}
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 2 }}>
              {question.question}
            </Typography>

            <RadioGroup
              value={answers[index] || ''}
              onChange={(e) => handleChange(index, e.target.value)}
            >
              {question.options.map((option, optionIndex) => (
                <FormControlLabel
                  key={optionIndex}
                  value={option}
                  control={<Radio />}
                  label={option}
                />
              ))}
            </RadioGroup>

            {results[index] && (
              <Typography
                variant="body2"
                color={results[index] === 'correct' ? 'success.main' : 'error.main'}
                sx={{ mt: 1 }}
              >
                {results[index] === 'correct' ? (
                  <>
                    <CheckIcon fontSize="small" sx={{ mr: 1 }} />
                    Correct!
                  </>
                ) : (
                  'Incorrect'
                )}
              </Typography>
            )}
          </Box>
        ))}

        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button
              variant="outlined"
              onClick={() => history("/register-dashboard", { replace: true })}
            >
              Back to Dashboard
            </Button>
            
            <Button
              variant="contained"
              onClick={acceptTerms}
              disabled={results.some(result => !result)}
            >
              Accept Terms & Submit
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};

export default SubjectiveTestComponent;

